import request from '@/config'

enum Apis {
    PerformPading = `/api/home/performwaittopay`,               // 履约合同付款申请
    ContractPeding = `/api/home/contractauditpedinglist`,       // 合同待审
    UserWorkInfo = `/api/home/getworkinfo`,                     // 获取用户待办任务统计
    PerformAmtInfo = `/api/home/getperformamountinfo`,          // 获取合同履约情况数据统计
}

const PerformPadingApi = (inputs: any): Promise<IResponse> =>
    request.post({
        url: Apis.PerformPading,
        data: inputs
    })

const ContractPedingApi = (inputs: any): Promise<IResponse> =>
    request.post({
        url: Apis.ContractPeding,
        data: inputs
    })

const UserWorkInfoApi = (): Promise<IResponse> =>
    request.post({
        url: Apis.UserWorkInfo, data: {}
    })

const PerformAmtInfoApi = (): Promise<IResponse> =>
    request.post({
        url: Apis.PerformAmtInfo,
        data: {}
    })

export {
    PerformPadingApi,
    ContractPedingApi,
    UserWorkInfoApi,
    PerformAmtInfoApi
}